import { useOperationsWithFields, Field } from '@tcc/shared-data-lib';
import { useMemo } from 'react';
import { olHeaders } from 'constants/api';

export const useFields = (operationsSelected: string[]) => {
  const {
    isLoading,
    operations,
    error
  } = useOperationsWithFields({
    config: { olHeaders },
    params: {
      operationIds: operationsSelected || [],
    },
  });

  const value = useMemo(() => {
    if (!operationsSelected || operationsSelected.length === 0) {
      return {
        fields: [] as Field[],
        isLoading: true,
        error: undefined
      };
    }

    let fields: Field[] = [];
    const fieldsUuids = [];

    if (!isLoading && operations) {
      fields = operations
      .filter(Boolean)
      .flatMap(({ operationName, fields: operationFields }) =>
        operationFields.nodes.map((field: Field) => {
          fieldsUuids.push(field.id);

          return {
            ...field,
            operationName,
          };
        })
      )
      .sort((a, b) => a.name.localeCompare(b.name));
    }

    return { fields, fieldsUuids, isLoading, error };
  }, [error, isLoading, operations, operationsSelected]);

  return { fields: value.fields, fieldsUuids: value.fieldsUuids, isLoading: value.isLoading, error: value.error };
};
